import React, {useCallback} from 'react';
import parse from 'html-react-parser';
import useDebounce from 'js/hooks/useDebounce/useDebounce';
import {slideToggle, slideUp} from 'js/helpers/toggleSlide';

import classes from './ExpandableSection.module.pcss';
import StatusItem from './StatusItem/StatusItem';
import BeforeCompletedMessage
    from 'js/containers/PostTypes/SelfLearning/LearningPath/FilterContent/CompletedMessage/BeforeCompletedMessage';


interface Props {
    id?: string,
    nodeRef: any,
    text: string,
    isOpened?: boolean,
    withStatus?: boolean,
    withTypeLabel?: boolean,
    postId?: number,
    statusCallback?: Function,
    beforeCompletedMessage?: string,
    showBeforeCompleteMessage?: boolean,
    additionalHandlerCallback?: Function,
    isStatusChecked?: boolean,
    insideEl?: any
}

const ExpandableSectionHeading = (
    {
        withStatus = false,
        postId = null,
        statusCallback = () => {},
        isStatusChecked = false,
        showBeforeCompleteMessage = false,
        beforeCompletedMessage = '',
        nodeRef, id = '', text, withTypeLabel = false, isOpened = false, additionalHandlerCallback = () => {}, insideEl = ''} : Props) => {
    const timeouts = {
        slide: 200,
        expandDebounce: 100
    };

    const expandCallback = useCallback((
        currentEl,
        currentContentBlock,
        expandedHeadings,
        expandedBlocks
    ) => {
        expandedHeadings?.forEach((item) => {
            if ((item !== currentEl) && item.classList.contains('Active')) {
                item.classList.remove('Active');
            }
        });
        expandedBlocks?.forEach((item) => {
            if ((item !== currentContentBlock) && item.classList.contains('ShowExpandSection')) {
                slideUp(item, 'ShowExpandSection', timeouts.slide, currentEl);
            }
        });
        slideToggle(currentContentBlock, 'ShowExpandSection', timeouts.slide, currentEl);
    }, [timeouts.slide]);

    const debouncedExpandCallback = useDebounce(expandCallback, timeouts.expandDebounce);

    const expandableHeadingHandler = useCallback((e) => {
        const currentEl = e?.currentTarget;
        let currentContentBlock = e?.currentTarget?.parentNode?.nextSibling;
        if (withTypeLabel) {
            currentContentBlock = currentContentBlock?.nextSibling;
        }
        const expandedHeadings = nodeRef?.current?.querySelectorAll(`h4.${classes.ExpandableSectionHeading}`);
        const expandedBlocks = nodeRef?.current?.querySelectorAll(`.${classes.ExpandableSectionInfo}`);
        if (!currentContentBlock || !nodeRef) {
            return;
        }
        debouncedExpandCallback(currentEl, currentContentBlock, expandedHeadings, expandedBlocks);
    }, [nodeRef, debouncedExpandCallback, withTypeLabel]);
    return (
        <div className={classes.Wrap}>
            <h4
                title={`${parse(text || '')}`}
                onClick={(e) => {
                    expandableHeadingHandler(e);
                    additionalHandlerCallback(e);
                }}
                id={id}
                className={`${classes.ExpandableSectionHeading} ${isOpened ? 'Active' : ''}`}>
                {parse(text || '')}
            </h4>
            {withStatus ? <StatusItem
                id={id}
                checked={isStatusChecked}
                statusCallback={statusCallback} /> : ''}
            <BeforeCompletedMessage show={showBeforeCompleteMessage} message={beforeCompletedMessage} postId={postId} />
            {insideEl}
        </div>
    );
};

export default ExpandableSectionHeading;
